import { resolveEndpoint } from '../endpointUtils';

export default {
	statusMapping: {
		uri: 'static-content-webapp-url:/content/FateOfPayments/error_messages_latest.json',
		method: 'GET',
		resolve(bankId, templateId) {
			return resolveEndpoint(this.uri, { bankId, templateId });
		},
	},
	getScheduledPayment: {
		uri: '/ibapi/v2/banks/:bankId/accounts/:scopeId/:accountId/payments?record_type=:mandateRecordType&start_index=:mandateStartIndex&max_records=:mandateMaxRecords',
		x_bpi_version: '1.3.0',
		method: 'GET',
		resolve(bankId, scopeId, accountId, mandateRecordType, mandateStartIndex, mandateMaxRecords) {
			return resolveEndpoint(this.uri, {
				bankId,
				scopeId,
				accountId,
				mandateRecordType,
				mandateStartIndex,
				mandateMaxRecords,
			});
		},
	},
	getUsersScheduledPayment: {
		uri: '/ibapi/v2/banks/:bankId/accounts/:scopeId/:accountId/payments/user?record_type=:mandateRecordType&start_index=:mandateStartIndex&max_records=:mandateMaxRecords',
		x_bpi_version: '1.3.0',
		method: 'GET',
		resolve(bankId, scopeId, accountId, mandateRecordType, mandateStartIndex, mandateMaxRecords) {
			return resolveEndpoint(this.uri, {
				bankId,
				scopeId,
				accountId,
				mandateRecordType,
				mandateStartIndex,
				mandateMaxRecords,
			});
		},
	},
	cancelBacsPayment: {
		uri: '/ibapi/v2/banks/:bankId/accounts/:scopeId/:accountId/payment/:paymentId',
		x_bpi_version: '1.3.0',
		method: 'DELETE',
		resolve(bankId, scopeId, accountId, paymentId) {
			return resolveEndpoint(this.uri, { bankId, scopeId, accountId, paymentId });
		},
	},
	getPaymentById: {
		uri: '/ibapi/v2/banks/:bankId/accounts/:scopeId/:accountId/payments/:paymentId',
		x_bpi_version: '1.3.0',
		method: 'GET',
		resolve(bankId, scopeId, accountId, paymentId) {
			return resolveEndpoint(this.uri, { bankId, scopeId, accountId, paymentId });
		},
	},
};
